import { ArrowLeft, Zap, Image, Video, Package } from 'lucide-react';
import { useEffect } from 'react';
import { PageShell } from './layout/PageShell';
import { ShareTalentfunnBlock } from './ShareTalentfunnBlock';

interface SubscriptionComingPageProps {
  onBack: () => void;
}

export function SubscriptionComingPage({ onBack }: SubscriptionComingPageProps) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white xl:bg-gradient-to-br xl:from-purple-50 xl:via-pink-50 xl:to-orange-50">
      <PageShell className="pt-page-safe-sm pb-android-pwa-doc xl:max-w-2xl xl:mx-auto xl:px-4 xl:px-8 xl:pt-5 xl:pb-24">
        <div className="pt-5 xl:bg-white xl:rounded-3xl xl:shadow-xl xl:border-2 xl:border-purple-100 xl:p-8">
          <button
            onClick={onBack}
            className="flex items-center gap-2 text-purple-600 hover:text-purple-700 mb-6 px-4 xl:px-0 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Tilbake</span>
          </button>

          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4 px-4 xl:px-0 bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent text-center">
            Ta talentet ditt til neste nivå!
          </h1>

          <div className="space-y-6 px-4 xl:px-0 text-gray-700 leading-relaxed">
            <p className="text-center">
              Her kommer medlemskap som vil gi deg det lille ekstra for å skille deg ut i mengden.
            </p>

            <section>
              <h2 className="text-lg font-semibold text-purple-900 mb-3">Dette kan du glede deg til:</h2>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                    <Zap className="w-4 h-4 text-purple-600" />
                  </span>
                  <span><strong className="text-gray-900">Boostet synlighet:</strong> Kom øverst i søkeresultatene hos arbeidsgivere.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                    <Image className="w-4 h-4 text-purple-600" />
                  </span>
                  <span><strong className="text-gray-900">Utvidet portefølje:</strong> Vis frem flere prosjekter.</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                    <Video className="w-4 h-4 text-purple-600" />
                  </span>
                  <span><strong className="text-gray-900">Video-pitch:</strong> Last opp video på prosjektene dine, og vis hvem du er &quot;live&quot;!</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-9 h-9 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0">
                    <Package className="w-4 h-4 text-purple-600" />
                  </span>
                  <span><strong className="text-gray-900">Publiser tjenester:</strong> Opprett tjenester og få forespørsler fra alle brukere.</span>
                </li>
              </ul>
            </section>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-5 border-2 border-purple-200">
              <p className="text-gray-700">
                Inntil videre: Gjør deg kjent med plattformen og vis verden hva du er god for gjennom profilen din. Vi sier fra så snart vi åpner for oppgraderinger!
              </p>
            </div>

            <ShareTalentfunnBlock />
          </div>
        </div>
      </PageShell>
    </div>
  );
}
